// 商品铺货
export const GOODS_SHELF = 'GOODS_SHELF'
